<template>
  <div id="data-list-list-view" class="p-5">
    <vs-table
      noDataText="Nenhum Registro Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      search
      pagination
      :max-items="itemsPerPage"
      v-model="selected"
      :data="dadosApoliceFiltrados"
      hoverFlat
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex">
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    :name="nameFileXls"
                    type="xls"
                  >
                    Exportar
                  </downloadexcel>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Status</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="filtrar('Ativos')">
                <span>Ativos</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Deletados')">
                <span>Deletados</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="filtrar('Todos')">
                <span>Todos</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <div
            @click.stop.prevent="adicionaApolice"
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Nova Apólice</span>
          </div>
        </div>

        <!------------ END ADD NOVO Tipo Pagamento ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                dadosApoliceFiltrados.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : dadosApoliceFiltrados.length
              }}
              de {{ dadosApoliceFiltrados.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="numeroApolice">NÚMERO DA APÓLICE</vs-th>
        <vs-th sort-key="valorFipeInicial">FAIXA VALORES FIPE</vs-th>
        <vs-th>GRUPOS</vs-th>
        <vs-th sort-key="deletedAt">STATUS</vs-th>
        <vs-th sort-key="">AÇÕES</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.numeroApolice }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                R${{ tr.valorFipeInicial.toFixed(2) }} à R${{
                  tr.valorFipeFinal.toFixed(2)
                }}
              </p>
            </vs-td>
            <vs-td>
              {{
                tr.grupos
                  ? tr.grupos
                      .filter((grupo) => !grupo.deletedAt)
                      .map((grupo) => grupo.nomeGrupo)
                      .join(', ')
                  : '-'
              }}
            </vs-td>
            <vs-td>
              <vs-chip
                class="py-2 text-sm font-medium"
                :color="`${tr.deletedAt ? 'danger' : 'success'}`"
                >{{ tr.deletedAt ? 'Deletado' : 'Ativo' }}</vs-chip
              >
            </vs-td>

            <vs-td>
              <div v-if="!tr.deletedAt" class="flex gap-2">
                <vs-button
                  size="small"
                  radius
                  color="primary"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click.stop.prevent="editarApolice(tr)"
                ></vs-button>
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click.stop.prevent="openModalConfirmacao(tr)"
                ></vs-button>
              </div>
              <div v-if="tr.deletedAt">
                <vs-button
                  size="small"
                  radius
                  color="warning"
                  icon-pack="feather"
                  icon="icon-refresh-cw"
                  @click.stop.prevent="openModalReativacao(tr)"
                >
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <FormApolice
      @closeModal="closeModal()"
      :openForm="modalApolice"
      @saveForm="saveForm()"
      :dados="apoliceSelecionada"
      :decoded="decoded"
      @guardaApolicesConcorrentes="guardaApolicesConcorrentes"
      :apolicesConcorrentes="apolicesConcorrentes"
    />

    <ModalConfimacao
      ref="confirmModal"
      :title="`${infoModal.title}`"
      :icon="`${infoModal.icon}`"
      :message="`${infoModal.msg}`"
      :iconColor="`${infoModal.iconColor}`"
      :iconPack="`${infoModal.iconPack}`"
      @confirmed="deleteApolice($event)"
    />

    <ModalConfimacao
      ref="reactiveModal"
      :title="`${infoModal.title}`"
      :icon="`${infoModal.icon}`"
      :message="`${infoModal.msg}`"
      :iconColor="`${infoModal.iconColor}`"
      :iconPack="`${infoModal.iconPack}`"
      @confirmed="reativarApolice($event)"
    />
  </div>
</template>

<script>
import service from '../../services';
import ModalConfimacao from '../../components/generic/GenericPromptModal.vue';
import downloadexcel from 'vue-json-excel';
import FormApolice from '../forms/FormApolice.vue';
import jwt from 'jsonwebtoken';
export default {
  data() {
    return {
      selected: [],
      itens: [],
      modalApolice: false,
      dadosApolice: [],
      itemsPerPage: 10,
      modalDelete: false,
      infoModal: {},
      idApoliceDelete: null,
      apoliceReactive: {
        idApolice: null,
        numeroApolice: null,
        grupos: null,
        valorFipeInicial: null,
        valorFipeFinal: null,
      },
      ultimoFiltro: 'Ativos',
      colunas: {},
      isMounted: false,
      dadosApoliceFiltrados: [],
      nameFileXls: 'Apolices',
      apoliceSelecionada: null,
      decoded: {},
      apolicesConcorrentes: null,
    };
  },
  methods: {
    /**
     * Opens the modal for adding a new policy.
     */
    adicionaApolice() {
      this.apoliceSelecionada = null;
      this.modalApolice = true;
    },

    /**
     * Opens the modal for editing a policy.
     * @param {object} apolice - The policy object to be edited.
     */
    editarApolice(apolice) {
      this.apoliceSelecionada = apolice;
      this.modalApolice = true;
    },

    /**
     * Retrieves user data from the decoded JWT token stored in local storage.
     */
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.decoded.idUsuario = this.decoded.id_usuario;
      this.decoded.idEmpresa = this.decoded.id_empresa;
    },

    /**
     * Closes the specified modal based on the given action.
     * Updates the corresponding modal state.
     * @method
     * @param {Object} acao - The action object containing id and modal properties.
     */
    closeModal() {
      this.modalApolice = false;
      this.apoliceSelecionada = null;
      this.apolicesConcorrentes = null;
    },

    /**
     * Fetches policies from the server.
     * Updates the policy data and applies the last filter.
     * Displays a notification in case of failure.
     * @returns {Promise<void>} - A promise that resolves when the policies are fetched and processed, or rejects with an error.
     */
    async buscaApolices() {
      try {
        this.$vs.loading();
        const { data } = await service.post(
          'apolice',
          'listar-todos-completo',
          {},
        );

        // Remove duplicate groups within each policy
        this.dadosApolice = data;

        this.filtrar(this.ultimoFiltro);
      } catch (error) {
        this.notify('danger', 'Falha ao listar apólices');
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Initiates the printing process after a short delay.
     * @method
     */
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },

    /**
     * Filters the policy data based on the given status.
     * Updates the filtered policy data.
     * @param {string} status - The status to filter policies by ('Todos', 'Ativos', 'Deletados').
     */
    filtrar(status) {
      this.ultimoFiltro = status;
      if (status === 'Todos') this.dadosApoliceFiltrados = this.dadosApolice;
      if (status === 'Ativos')
        this.dadosApoliceFiltrados = this.dadosApolice.filter(
          (apolice) => !apolice.deletedAt,
        );
      if (status === 'Deletados')
        this.dadosApoliceFiltrados = this.dadosApolice.filter(
          (apolice) => apolice.deletedAt,
        );
    },

    /**
     * Opens a confirmation modal before deleting a policy.
     * Sets up the modal with appropriate information.
     * @param {object} apolice - The policy object to be deleted.
     */
    openModalConfirmacao(apolice) {
      this.idApoliceDelete = apolice.idApolice;
      this.infoModal = {
        title: 'Atenção!',
        msg: `Os registros da Apólice "${apolice.numeroApolice}" serão deletados!`,
        icon: 'icon-alert-triangle',
        iconColor: 'warning',
        iconPack: 'feather',
      };
      this.$refs.confirmModal.showModal();
      this.modalDelete = true;
    },

    /**
     * Deletes a policy.
     * Displays a loading indicator during the deletion process.
     * Updates the policy data after deletion.
     * @param {boolean} confirmed - Indicates whether the deletion is confirmed.
     */
    async deleteApolice(confirmed) {
      if (confirmed) {
        try {
          this.$vs.loading();
          await service.post('apolice', 'deletar', {
            idApolice: this.idApoliceDelete,
            idUsuario: this.decoded.idUsuario,
          });
          this.notify('success', 'Apólice deletada!');
          this.buscaApolices();
        } catch (error) {
          this.notify('danger', 'Não foi possível deletar apólice');
        } finally {
          this.$vs.loading.close();
        }
      }
      this.idApoliceDelete = null;
    },

    /**
     * Opens a confirmation modal before reactivating a policy.
     * Sets up the modal with appropriate information.
     * @param {object} apolice - The policy object to be reactivated.
     */
    openModalReativacao(apolice) {
      this.apoliceReactive = { ...apolice, idUsuario: this.decoded.idUsuario };
      this.infoModal = {
        title: 'Atenção!',
        msg: `Os registros da Apólice "${apolice.numeroApolice}" serão reativados!`,
        icon: 'icon-alert-triangle',
        iconColor: 'warning',
        iconPack: 'feather',
      };
      this.$refs.reactiveModal.showModal();
    },

    /**
     * Reactivates a policy.
     * Displays a loading indicator during the Reactivation process.
     * Updates the policy data after reactivation.
     * @param {boolean} confirmed - Indicates whether the reactivation is confirmed.
     */
    async reativarApolice(confirmed) {
      if (confirmed) {
        try {
          this.$vs.loading();
          const apolicesConcorrentesResult = await service.post(
            'apolice',
            'reativar',
            this.apoliceReactive,
          );

          const { data } = apolicesConcorrentesResult;
          const possuiApolicesConcorrentes = Array.isArray(data) && data.length;
          if (possuiApolicesConcorrentes) {
            this.notify(
              'danger',
              'Existem apólices ativas com configurações conflitantes',
            );
            return;
          }

          this.buscaApolices();
        } catch (error) {
          this.notify('danger', 'Não foi possível reativar a apólice');
        } finally {
          this.$vs.loading.close();
        }
        this.apoliceReactive = null;
      }
    },

    /**
     * Displays a notification message.
     * @param {string} color - The color of the notification (e.g., 'success', 'danger', 'warning').
     * @param {string} msg - The message to be displayed in the notification.
     * @param {number} time - The duration of the notification display (in milliseconds).
     * @returns {object} - The notification object.
     */
    notify(color, msg, time = 2500) {
      return this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: msg,
        color: color,
        time: time,
      });
    },

    /**
     * Saves the form data and updates the policy data.
     * Closes the modal for adding/editing a policy.
     */
    saveForm() {
      this.buscaApolices();
      this.modalApolice = false;
    },

    guardaApolicesConcorrentes(apolicesConcorrentes) {
      this.apolicesConcorrentes = apolicesConcorrentes;
    },
  },
  mounted() {
    this.buscaApolices();
    this.getDecoded();
    this.isMounted = true;
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  components: {
    FormApolice,
    ModalConfimacao,
    downloadexcel,
  },
};
</script>
<style lang="scss">
#data-list-list-view {
  .vs-table--header {
    display: flex;
    flex-wrap: wrap-reverse;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    > span {
      display: flex;
      flex-grow: 1;
    }
    .vs-table--search {
      padding-top: 0;
      .vs-table--search-input {
        padding: 0.9rem 2.5rem;
        font-size: 1rem;
        & + i {
          left: 1rem;
        }
        &:focus + i {
          left: 1rem;
        }
      }
    }
  }
  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;
    tr {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
      cursor: default;
      td {
        padding: 16px;
        &:first-child {
          border-top-left-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
        }
        &:last-child {
          border-top-right-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
        }
      }
      td.td-check {
        padding: 20px !important;
      }
    }
  }
  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;
      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
      }
    }
    th.td-check {
      padding: 0 15px !important;
    }
    tr {
      background: none;
      box-shadow: none;
    }
  }
  .vs-table--pagination {
    justify-content: center;
  }
}
</style>
